module.exports = __webpack_public_path__ + "img/email_sent.74917076.png";